import { render } from "./MapKosong.vue?vue&type=template&id=04ce2513&scoped=true&ts=true"
import script from "./MapKosong.vue?vue&type=script&lang=ts"
export * from "./MapKosong.vue?vue&type=script&lang=ts"

import "./MapKosong.vue?vue&type=style&index=0&id=04ce2513&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ce2513"]])

export default __exports__